import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";
import { GetWalletDetails } from "../../../../services";
import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";

export default class CreateWalletPackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      packageName: "",
      amount: "",
      bonusAmount: "",
      description: "",
      status: "Active", // default active
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleSubmit = async () => {
    this.setState({ isLoaded: true });

    const { amount, status } =
      this.state;

    if (!amount) {
      NotificationManager.error("Required fields missing", "Input Error");
      this.setState({ isLoaded: false });
      return;
    }

    const data = {
      amount: Number(amount),
      status: status,
    };

    const response = await GetWalletDetails.getWalletPackageAdd(data);
    this.setState({ isLoaded: false });

    if (response) {
      NotificationManager.success(
        "Wallet package created successfully",
        "Message"
      );
      this.props.history.goBack();
    } else {
      NotificationManager.error("Something went wrong!", "Error");
    }
  };

  render() {
    const { isLoaded, packageName, amount, bonusAmount, description, status } =
      this.state;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9">
            <h2 className="mt-30 page-title">Create Wallet Package</h2>
          </div>
          <div className="col-lg-5 col-md-3 back-btn">
            <Button variant="contained" onClick={() => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>

        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">Dashboard</li>
          <li className="breadcrumb-item">Wallet</li>
          <li className="breadcrumb-item active">Create Package</li>
        </ol>

        <Paper className="user-management" style={{ padding: "1rem" }}>
          {isLoaded && <Loader />}

          <div className="row">
            <div className="col-md-6 form-group">
              <label>Amount (₹)</label>
              <input
                type="number"
                className="form-control"
                name="amount"
                value={amount}
                onChange={(e) => this.handleChange(e)}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Status</label>
              <select
                className="form-control"
                name="status"
                value={status}
                onChange={(e) => this.handleChange(e)}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <button
            className="btn btn-primary col-sm-3 mt-3 py-2"
            onClick={this.handleSubmit}
          >
            Save
          </button>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/wallet/create/index.js